function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { BrandSymbol } from '../../../components/dataDisplay';
import { _ImageIcon } from '../../../components/internal';
import { Icon } from '../../../foundations/Icon';
import { isBrandSymbol } from '../../../theme/icons/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SelectionCardImageIcon = _ref => {
  var {
    imageIcon,
    icon,
    isDisabled
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [imageIcon && /*#__PURE__*/_jsx(_ImageIcon, _objectSpread(_objectSpread({}, imageIcon), {}, {
      isDisabled: isDisabled
    })), icon && /*#__PURE__*/_jsx(_Fragment, {
      children: isBrandSymbol(icon) ? /*#__PURE__*/_jsx(BrandSymbol, {
        type: icon,
        isDisabled: isDisabled
      }) : /*#__PURE__*/_jsx(Icon, {
        type: icon,
        isDisabled: isDisabled
      })
    })]
  });
};
//# sourceMappingURL=SelectionCardImageIcon.js.map